// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__7-2fx","label":"Category_label__29lsi","content":"Category_content__4XZK-","header":"Category_header__1ZGvt","location":"Category_location__2BrEZ"};